<template>
	<div class="sapphire-payment-portal" v-if="!!district.CWP_ALLOW_PAYMENTS_FLG && district.CWP_ALLOW_PAYMENTS_FLG === 'Y' && paymentsAreAllowed">
		<modal 	:modal-title="$t('MAIN_CONTENT.Fees.RevTrakWebstoreModalTitle')"
						:show="getShowWebstoreModal"
						dialog-size="lg"
						name="webstore-modal"
						v-if="!!selectedStudent"
						@close="closeWebstoreModal()">
			<template slot-scope="modalProps">
				<div class="instructions alert alert-vanco" v-html="headerText" v-if="roleRules.FEES_DESCRIPTION_FLG === 'Y' && headerText.length > 0"/>
				
				<div class="row sapphire-payment-portal">
					<div class="col-md-12">
					<div class="panel webstore-panel">
						<div id="panel-body-panel-fees" class="panel-body" style="font-size:16px;">
							<h2 class="text-center">Balance {{parseFloat(balance.BALANCE).toFixed(2) | dollar}}</h2>
							<p class="text-center">
								<i>
									<small v-if="balance.MODIFIED_DATE !== ''">Last updated as of {{balance.MODIFIED_DATE | datetime('MMMM, DD YYYY HH:mm:ss', 'MM/DD/YYYY h:mm a') }}</small>
									<small v-else>last update not available</small>
								</i>
							</p>
						</div>
					</div>
				</div>

					<div class="col-md-6 text-center" v-for="webstore in webstores" :key="webstore">
						<div class="panel webstore-panel">
							<div class="panel-heading">
								<h2 style="margin-top: 0px"><small>{{buildVancoWebstoreName(webstore)}}</small></h2>
							</div>
							<div id="panel-body-panel-fees" class="panel-body" style="font-size:16px;">
								<a target="_blank" :href="buildVancoWebstoreUrl(webstore)" class=""><img src="includes/images/RevTrakPay.svg" height="35" alt="RevTrak" /><aria-new-tab-message :message="$t( 'MAIN_CONTENT.Accessibility.opensInNewTab' )" /></a>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template slot="footer">
				<button type="button"
								class="btn btn-transparent pull-right"
								@click="closeWebstoreModal()">
					{{ $t('MAIN_CONTENT.commonContent.closeButton') }}
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
	import { mapGetters, mapMutations } from 'vuex';
	import Modal from 'COMMONS/shared/Modal/Modal.vue';

	import Payments from '../../api/Payments';
	import DistrictImage from '../../api/DistrictImage';
	import Fees from '../../api/Fees';
	import FeesHeader from '../../api/FeesHeader';

	export default {
		components: {
			Modal,
		},
		data(){
			return {
				district: {},
				preferences: {},
				headerText: "",
				balance: {},
			}
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules', 'getShowWebstoreModal']),
			webstores(){
				let allWebstores = [];
				for( let i=0; i<this.selectedStudent.ENROLLMENT.length; i++){
					let school = this.selectedStudent.ENROLLMENT[i];
					if( (!!this.preferences.schools && !!this.preferences.schools[school.SCHOOL_ID]
							&& !!this.preferences.schools[school.SCHOOL_ID].WEBSTORE_URL
							&& !!this.preferences.schools[school.SCHOOL_ID].WEBSTORE_PROVIDER)
						){
						allWebstores.push(school.SCHOOL_ID);
					} else if( allWebstores.indexOf("DISTRICT") === -1) {
						allWebstores.push("DISTRICT");
					}
				}
				return allWebstores;
			},
			paymentsAreAllowed(){
				return !!this.roleRules && !!this.roleRules.FEES_ALLOW_PAYMENTS_FLG && this.roleRules.FEES_ALLOW_PAYMENTS_FLG === 'Y';
			},
		},
		methods:{
			...mapMutations(['setShowWebstoreModal']),
			closeWebstoreModal(){
				this.setShowWebstoreModal(false);
			},
			loadBalance() {
				const self = this;

				let fees = new Fees({
					route: 'fees/external-balance',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = fees.get();

				promise.then(response => {
					self.$set(self, 'balance', response.data.data);
				})
				.catch(error => {
					console.log(error);
				});
			},
			buildVancoWebstoreName(id){
				if( id === 'DISTRICT' ){
					return this.district.DISTRICT_DESC + ' Webstore';
				}

				if( !!this.preferences && !!this.preferences.schools[id] && !!this.preferences.schools[id].WEBSTORE_URL && !!this.preferences.schools[id].WEBSTORE_PROVIDER ){
					let school = this.selectedStudent.ENROLLMENT.find(e => {
						return e.SCHOOL_ID === id;
					})
					return school.SCHOOL_TITLE + ' Webstore';
				}

				return 'Webstore';
			},
			buildVancoWebstoreUrl(id){
				if( id === 'DISTRICT' ){
					return `https://${this.preferences.district.WEBSTORE_URL}/fee-management?provider=${this.preferences.district.WEBSTORE_PROVIDER}`;
				}

				if( !!this.preferences && !!this.preferences.schools[id] && !!this.preferences.schools[id].WEBSTORE_URL && !!this.preferences.schools[id].WEBSTORE_PROVIDER ){
					return `https://${this.preferences.schools[id].WEBSTORE_URL}/fee-management?provider=${this.preferences.schools[id].WEBSTORE_PROVIDER}`;
				}

				return '';
			},
			getHeader() {
				const self = this;

				let header = new FeesHeader({
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = header.get();

				promise.then( response => {
					if( header.getResponseData().length > 0 ) {
						self.headerText = header.getResponseData();
					}
				})
				.catch(error => {
					console.log(error);
				});
			},
			getDistrictImage() {
				const self = this;
				const district = new DistrictImage({});
				const promise = district.get();
				promise.then(response => {
					self.$set(self, 'district', district.getResponseData());
				});
			},
			getPreferences(){
				const self = this;
				let payment = new Payments({
					routeParams: {
						service: 'vanco',
						action: 'preferences',
					},
				});

				let paymentPromise = payment.get();
				paymentPromise.then(response =>{
					self.preferences = response.data.data;
				});

				return paymentPromise
			},
		},
		created(){
			this.getDistrictImage();
			this.getPreferences();
			this.loadBalance();
			this.getHeader();
		}
	}
</script>

<style>
	.legal-footer p{
		line-height: 10px;
	}
	.legal-footer small {
		font-size: 8px;
	}
	.postal-code-input::-webkit-outer-spin-button,
	.postal-code-input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	.postal-code-input {
		-moz-appearance: textfield;
	}
	.sapphire-payment-portal{
		margin-bottom: 25px;
	}
	#payment-amount{
		margin-bottom: 50px;
	}
	#payment-form iframe {
		height: 20px !important;
	}
	#payment-amount #other-amount {
		width: 125px;
		border-radius: 6px;
		padding: 4px 6px;
	}
	.success-icon{
		font-size: 84px;
	}
	.cc-info-input{
		border: none;
		padding-top: 5px;
		padding-left: 0px;
		padding-right: 0px;
		box-shadow: none;
		font-size: 16px;
	}
	.cc-info-input::placeholder{
		color: #ccc;
	}
	.cc-info-input:focus{
		box-shadow: none;
	}

	.payment-processing-spinner{
		font-size: 64px;
		animation-name: spin;
		animation-duration: 3000ms;
		animation-iteration-count: infinite;
		animation-timing-function: linear;
		display: inline-block;
		color: #312852;
	}
	@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
	}

	.sapphire-payment-portal .modal-title{
		font-size: 1.6em;
		line-height: 1;
	}
	.sapphire-payment-portal .modal-title span{
		position: relative;
		top: 2px;
	}
	#payment-processing{
		margin-top: 25px;
		margin-bottom: 25px;
	}
	#payment-amount h2{
		margin-top: 10px;
	}
	.sapphire-payment-portal a{
		color: #604fa1;
	}
	.sapphire-payment-portal h2, .sapphire-payment-portal .modal-title, .sapphire-payment-portal .pay-through-vanco-btn{
		color: #312852;
	}
	.alert-vanco{
		background: #eae8f4;
		border-color: #d3cde7;
		color: #312852;
	}
	.sapphire-payment-portal .btn-vanco{	
		background: #312852;
		color: #FFF;
	}
</style>
